import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { HasPermissionWrapperComponent } from '@wajeez-web/components/helpers';
import React from 'react';
// import HasPermissionWrappercomponent from "../../components/WrapperComponents/hasPermissionWrapperComponent";
// import { PageHeaderTypes } from "../../constants/types/componentsTypes/PageHeadertypes";
// import BreadCrumbs from "../../components/Navigation/Breadcrumbs";
// import InnerpPageToggleButton from "../../components/HelperComponents/InnerPageToggleButton";
// import ReturnTranslatedText from "../../util/localization/ReturnTranslatedText";
export interface PageHeaderTypes {
  title: string | React.ReactElement<any>;
  endSideComponent?: PageHeaderEndSideComponentType[];
  breadCrumbsLinks?: { title: string; link?: string }[];
  withoutCard?: boolean;
  bottomSidecomponent?: JSX.Element;
  hasToggleButton?: boolean;
}

export interface PageHeaderEndSideComponentType {
  element: JSX.Element;
  permission?: string[];
}

const PageHeader = ({
  title,
  breadCrumbsLinks,
  endSideComponent,
  bottomSidecomponent,
  withoutCard,
  hasToggleButton,
}: PageHeaderTypes) => {
  return (
    <div
      className={` space-y-3 ${
        !withoutCard &&
        'bg-white border-b px-4  xl:p-4 lg: lg:py-3 md:py-2 border-warmGray-200 sm:px-4 py-4'
      }`}
    >
      <div
        className={`flex flex-col sm:flex-row flex-0 sm:items-center sm:justify-between  `}
      >
        <div className="flex-1 min-w-0">
          {/* {breadCrumbsLinks && <BreadCrumbs data={breadCrumbsLinks} />} */}
          <div className="">
            {typeof title === 'string' ? (
              <div className="xl:text-4xl lg:tex-3xl md:text-2xl font-extrabold flex space-s-3">
                {/* {hasToggleButton && <InnerpPageToggleButton />} */}
                <ReturnTranslatedText
                  origintext={title}
                  text={`pageHeader.${title}`}
                />
              </div>
            ) : (
              title
            )}
          </div>
        </div>
        <div className="flex flex-shrink-0 items-center space-s-1  sm:mt-0 sm:ms-4">
          {endSideComponent &&
            endSideComponent.map((item, i) =>
              item.permission ? (
                <HasPermissionWrapperComponent
                  key={'endSideComponent' + i}
                  permissions={item.permission}
                >
                  <div>{item.element}</div>
                </HasPermissionWrapperComponent>
              ) : (
                <div key={'endSideComponent' + i}>{item.element}</div>
              )
            )}
        </div>
      </div>
      <div className="w-full">{bottomSidecomponent}</div>
    </div>
  );
};

export default PageHeader;
